<template>
    <div class="select-client-modal">
        <ItemsSearchAndSelect
            v-model="selected"
            :list="list"
            radioGroupName="clientsList"
            inputName="client_select"
            itemCreateModalName="ClientItemModal"
            itemCreateModalTitle="§eq_operator.create_new_operator_modal_title"
            searchPlaceholder="§ui.search_equipment_operator"
            :columns="columns"
            class="mb-6"
        />

        <div class="flex justify-start gap-2">
            <CoreButton
                :disabled="selected === null"
                label="§ui_button.select"
                icon="pi-arrow-right"
                @click="handleSet"
            />

            <CoreButton
                label="§ui_button.cancel"
                variant="tertiary"
                @click="closeModal"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { useCafStore } from '@/stores/caf'
import { useModalStore } from '@/stores/modal'
import CoreButton from '@/components/core/CoreButton.vue'
import ItemsSearchAndSelect from './ItemsSearchAndSelect.vue'

export default {
    name: 'SelectClientModal',

    components: {
        ItemsSearchAndSelect,
        CoreButton,
    },

    data() {
        return {
            cafStore: useCafStore(),
            modalStore: useModalStore(),

            list: null,
            selected: null,

            columns: [
                { label: '§client.country', field: 'country_name' },
                { label: '§client.vat_identification_number', field: 'vat_identification_number' },
            ],
        }
    },

    mounted() {
        this.getList()
    },

    methods: {
        async getList() {
            this.list = await this.cafStore.getItemList('client.index')
        },

        handleSet() {
            this.cafStore.sharedInputs.client_select = this.selected

            const client = this.list.filter((item) => item.id === this.selected)[0]

            this.cafStore.sharedInputs.client_select_name = client.name
            this.cafStore.sharedInputs.operator_country_id = client.client_country_id

            this.modalStore.setClose()
        },

        closeModal() {
            this.modalStore.setClose()
        },
    },
}
</script>
